export { RegistrationView } from './RegistrationView';
